<div *ngIf="successMessage" class="alert alert-success">
    {{ successMessage }}
  </div>
  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>
   
  